import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogOut, Shield } from "lucide-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Button } from "../components/ui/Button";
import { Card, CardTitle } from "../components/ui/Card";
import { useLanguage } from "../lib/LanguageContext";
import { APP_ROUTES } from "../routing/routes";
const AwaitingActivation = () => {
    const { t } = useLanguage();
    const { session, isAuthenticated, canAccessTrading, logout, refreshUser } = useAuth();
    const navigate = useNavigate();
    const status = session?.user.activation_status;
    useEffect(() => {
        if (isAuthenticated && canAccessTrading) {
            void navigate(APP_ROUTES.dashboard, { replace: true });
        }
    }, [isAuthenticated, canAccessTrading, navigate]);
    if (!isAuthenticated || !session) {
        return null;
    }
    return (_jsx("div", { className: "mx-auto max-w-lg px-3 py-12 sm:px-4", children: _jsxs(Card, { className: "border-border/80 p-6 shadow-sm", children: [_jsxs("div", { className: "mb-4 flex items-center gap-2 text-amber-600 dark:text-amber-400", children: [_jsx(Shield, { className: "h-8 w-8 shrink-0", "aria-hidden": true }), _jsx(CardTitle, { className: "m-0 text-lg", children: t("activation.title") })] }), _jsx("p", { className: "mb-2 text-sm text-foreground", children: t("activation.lead", { email: session.user.email }) }), _jsx("p", { className: "mb-4 text-sm text-muted-foreground", children: status === "suspended" ? t("activation.hintSuspended") : t("activation.hintPending") }), _jsx("p", { className: "mb-6 text-xs text-muted-foreground", children: t("activation.apiNote") }), _jsxs("div", { className: "flex flex-wrap gap-2", children: [_jsx(Button, { type: "button", onClick: () => {
                                void (async () => {
                                    await refreshUser();
                                })();
                            }, children: t("activation.refreshStatus") }), _jsxs(Button, { type: "button", variant: "secondary", onClick: () => {
                                logout();
                                void navigate(APP_ROUTES.login, { replace: true });
                            }, children: [_jsx(LogOut, { className: "mr-1 h-4 w-4", "aria-hidden": true }), t("nav.logout")] })] })] }) }));
};
export default AwaitingActivation;
